<section class="bg-white">
  <div class="w-full">
    <h2 class="mb-2 text-xl font-semibold leading-none text-gray-700 md:text-2xl flex flex-wrap justify-between">
      {{ detailsViewConfig?.title }}
      <div class="text-white text-xs font-medium place-self-end me-10">
        @if (detailsViewConfig?.translationStateTerminal) {
          <span
            class="rounded-full me-2 px-2.5 py-0.5 whitespace-nowrap"
            [ngClass]="
              commonUtils.translationStateToColor($safeNavigationMigration(detailsViewConfig?.translationStateTerminal))
            "
          >
            UT:
            {{
              commonUtils.friendlyTranslationState(
                $safeNavigationMigration(detailsViewConfig?.translationStateTerminal)
              )
            }}
          </span>
          @if (detailsViewConfig?.translationStateDocumentation) {
            <span
              class="rounded-full px-2.5 py-0.5 whitespace-nowrap"
              [ngClass]="
                commonUtils.translationStateToColor(
                  $safeNavigationMigration(detailsViewConfig?.translationStateDocumentation)
                )
              "
            >
              Doc:
              {{
                commonUtils.friendlyTranslationState(
                  $safeNavigationMigration(detailsViewConfig?.translationStateDocumentation)
                )
              }}
            </span>
          }
        }
      </div>
    </h2>
    <p class="mb-3 font-extrabold leading-none text-amazone-orange text-xs">
      {{ detailsViewConfig?.shortDescription }}
    </p>
    <dl>
      <dt class="mb-2 font-semibold leading-none text-gray-700">
        {{ detailsViewConfig?.mainDescriptionLabel }}
      </dt>
      <dd class="mb-4 font-light text-gray-500 sm:mb-5">
        @for (
          line of commonUtils.breakIntoLines($safeNavigationMigration(detailsViewConfig?.mainDescription));
          track $index
        ) {
          <p class="break-all">{{ line }}</p>
        }
      </dd>
    </dl>
    @for (item of getDetailsBySequenceOrder(); track $index) {
      @if (isTextArea(item)) {
        <dl>
          <dt class="mb-2 font-semibold leading-none text-gray-700 flex items-center">
            {{ item.label }}
            @if (item.isTranslatable) {
              <app-language-icon [size]="5" class="ms-2 text-amazone-orange"></app-language-icon>
            }
          </dt>
          <dd class="mb-4 font-light text-gray-500 sm:mb-5">
            @for (line of commonUtils.breakIntoLines(item.value); track $index) {
              <p class="break-all whitespace-pre-wrap">{{ line }}</p>
            }
          </dd>
        </dl>
      } @else if (isSingleLineDetail(item)) {
        <dl class="flex items-center space-x-6">
          @for (value of item.attributes; track $index) {
            <div>
              <dt class="mb-2 font-semibold leading-none text-gray-700">
                {{ value.label }}
              </dt>
              <dd class="mb-4 font-light text-gray-500 sm:mb-5 break-all">{{ value.value }}</dd>
            </div>
          }
        </dl>
      } @else if (isItemBadge(item)) {
        <div class="mb-6">
          <dt class="mb-2 font-semibold leading-none text-gray-700">
            {{ item.itemBadgeLabel }}
          </dt>
          <span
            [ngClass]="{
              'bg-amazone-green': !detailsViewConfig?.badge?.isEmpty,
              'bg-orange-600': $safeNavigationMigration(detailsViewConfig?.badge?.isEmpty),
            }"
            class="text-white text-xs font-medium px-2.5 py-0.5 rounded-full"
          >
            @if (detailsViewConfig!.badge!.itemId) {
              <a
                (click)="
                  navigateWithId(
                    detailsViewConfig!.badge!.itemId,
                    detailsViewConfig!.badge!.itemSearchTerm!,
                    detailsViewConfig!.badge!.itemType!
                  )
                "
                class="cursor-pointer"
              >
                {{ detailsViewConfig!.badge!.title }}
              </a>
            } @else {
              {{ detailsViewConfig!.badge!.title }}
            }
          </span>
        </div>
      } @else if (isAlarmMaskView(item)) {
        <app-alarm-mask-view
          [alarmMasks]="item.alarmMasks"
          [maskTranslationState]="item.maskTranslationState"
        ></app-alarm-mask-view>
      } @else if (isSeparator(item)) {
        <hr class="mt-1 mb-6 border-gray-200" />
      } @else if (isApprovalStatus(item)) {
        <dl>
          <dt class="mb-2 font-semibold leading-none text-gray-700 flex items-center">Approval Status</dt>
          <dd class="mb-4 font-light text-gray-500 sm:mb-5">
            <app-approval-stats [approvalStatus]="item.approvalStatus"></app-approval-stats>
          </dd>
        </dl>
      } @else if (isTrReviewStatistics(item)) {
        <dl>
          <dt class="mb-2 font-semibold leading-none text-gray-700 flex items-center">TR Review Statistics</dt>
          <dd class="mb-4 font-light text-gray-500 sm:mb-5">
            <app-tr-review-stats [trReviewsStats]="item.trReviewStatistics"></app-tr-review-stats>
          </dd>
        </dl>
      }
    }
    @if (detailsViewConfig?.internalNotes) {
      <dl class="bg-amazone-beige p-2 rounded-lg mb-6">
        <dt class="mb-2 font-semibold leading-none text-gray-700">Internal notes</dt>
        <dd class="mb-4 font-light text-gray-500 sm:mb-5">
          @for (
            line of commonUtils.breakIntoLines($safeNavigationMigration(detailsViewConfig?.internalNotes));
            track $index
          ) {
            <div>
              {{ line }}
            </div>
          }
        </dd>
      </dl>
    }
    @if (detailsViewConfig?.displayLinkedDtcs) {
      <app-linked-dtcs [errorMessageId]="$safeNavigationMigration(detailsViewConfig?.entityId)"></app-linked-dtcs>
    }
  </div>
</section>
